import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import _ from 'lodash';
import styled from 'styled-components';

import AdminMenu from './Menus/AdminMenu';
import Header from '../Header';
import Toast from '../Toast';

import { apiCall } from '../../utils';

const Wrap = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
`;

const ViewWrap = styled.div`
	width: 100%;
	margin: 0 auto;
  height: 100%;
`;

const BaseComponent = ViewComponent => class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			userInfo: {},
			menus: [],
			userAuthority:[],
		};
	}

	componentWillMount() {
		Toast.createContainer({});

		if (window.location.pathname !== '/login') {
			let path = 'admin';

			this.setState({
				path: path,
			}, () => {
				this.getMyMenu();
			});
		}
	}

	getMyMenu = () => {
		const { path } = this.state;

		apiCall.get('/api/admin/common', {
			path: path
		}).then(data => {
			let headers = []

            headers = _.clone(AdminMenu);

			const myMenu = data.menu;  // 내가 볼수 있는 페이지 ID ( type: Array )
			const newHeader = [];
			
			const hLen = headers.length;
			for (let h = 0; h < hLen; h++) {
				const { title, menus } = headers[h];
				const newMenu = [];
				const mLen = menus.length;
	
				for (let i = 0; i < mLen; i++) {
					const menu = menus[i];
	
					if (_.includes(myMenu, menu.id)) {
						newMenu.push(menu);

					} else if (menu.id === 'non_auth') {
						newMenu.push(menu);
					}
				}
				
				if (newMenu.length > 0) {
					let data = { menus: newMenu };
					if (title) data.title = title;
					newHeader.push(data);
				}
			};

			this.setState({
				userAuthority: data.function,
				userInfo: data.userInfo,
				menus: newHeader,
			});
		}).catch(err => {
			console.log(err);
		});
	}

	render() {
		const { pathname } = window.location;

		const user_type = 'admin';
		
		const Urls = [
			'/login',
			'/admin'
		]

		if (_.includes(Urls, pathname)) {
			return <ViewComponent />;
		
		} else {
			return (
				<Router basename={pathname}>
					<Wrap>
						<Header {...this.state} user_type={user_type} />
						<ViewWrap>
							<ViewComponent {...this.state} />
						</ViewWrap>
					</Wrap>
				</Router>
			);
		}
	}
};

export default BaseComponent;



// WEBPACK FOOTER //
// ./client/components/BaseComponent/index.js